import React from "react";
import ReactDOM from "react-dom";
import styles from "./index.module.scss";

interface BottomSheetProps {
  visible: boolean;
  title?: string;
  onClose: () => void;
  onConfirm?: () => void; // 提供则显示底部「确定」按钮
  confirmText?: string;
  children: React.ReactNode;
  zIndex?: number; // 需高于宿主覆盖层（如异响覆盖层 z-index:1000）
  className?: string;
}

/**
 * 通用底部弹层外壳：半透明遮罩 + 贴底白卡（圆角）+ 顶部标题 + 右上角 X + 可选底部「确定」。
 * 中间内容由 children 自定义（滚轮 / 列表 / 表单等）。
 * 自建固定布局，不依赖项目 Modal，避免其内联定位在覆盖层内失准。
 */
export default function BottomSheet(props: BottomSheetProps) {
  const {
    visible,
    title = "",
    onClose,
    onConfirm,
    confirmText = "确定",
    children,
    zIndex = 2000,
    className = "",
  } = props;

  if (!visible) return null;

  return ReactDOM.createPortal(
    <div className={`${styles.mask} ${className}`} style={{ zIndex }} onClick={onClose}>
      <div className={styles.sheet} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <span className={styles.title}>{title}</span>
          <i className={styles.close} onClick={onClose} />
        </div>
        {children}
        {onConfirm && (
          <div className={styles.confirm} onClick={onConfirm}>
            {confirmText}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}
